export const formatTime = (secs) => {
  return `0:${String(secs).padStart(2, "0")}`;
};

export const formatStreamDuration = (isoDateString) => {
  const startTime = new Date(isoDateString); // Parse the start time
  const currentTime = new Date(); // Get the current time

  // Calculate the difference in milliseconds
  const elapsedTimeInMs = currentTime - startTime;

  // Convert milliseconds to seconds, minutes, hours, etc.
  const elapsedSeconds = Math.floor(elapsedTimeInMs / 1000);
  const hours = Math.floor(elapsedSeconds / 3600);
  const minutes = Math.floor((elapsedSeconds % 3600) / 60);
  const seconds = elapsedSeconds % 60;

  // Return the time elapsed in a human-readable format
  const formattedHours = hours.toString().padStart(2, "0");
  const formattedMinutes = minutes.toString().padStart(2, "0");
  const formattedSeconds = seconds.toString().padStart(2, "0");

  // Return the time elapsed in HH:MM:SS format
  return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
};
